import { CSSObject } from '@chakra-ui/react';
import { EWithdrawalStatus } from '@/lib/DBModels';
import { TWithdrawalStatus } from '../RequestedWithdrawalCard/styles/RequestedWithdrawalCard.styles';
import { CustomButtonProps } from '@/components/Button/Button';

export const Heading: CSSObject = {
  fontSize: 'sm',
  mb: '1',
};

export const DividerWithdrawal: CSSObject = {
  borderBottom: '1px solid',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
  borderBottomColor: 'blackAlpha.400',
  borderStyle: 'dashed',
};

export const WithdrawalCardContent: CSSObject = {
  color: 'white',
  fontWeight: 'semibold',
};

export const TextDescription: CSSObject = {
  fontSize: 'xs',
};

export const buttonAddAccountProps: CustomButtonProps = {
  variant: 'solid',
  lineHeight: 'normal',
  w: 'full',
  mb: '2',
};

export const ButtonWithdrawal: CSSObject = {
  variant: 'secondary',
  fontWeight: 'normal',
};

export const ButtonIncrease: CSSObject = {
  variant: 'secondary',
};

export const InputWrapperWithdrawal: CSSObject = {
  '.chakra-form__helper-text': {
    bg: 'red.600',
    boxShadow:
      '0px 2px 4px 0px rgba(0, 0, 0, 0.2), 0px 1px 0px 0px rgba(255, 255, 255, 0.2) inset',
    color: 'blackAlpha.800',
    borderRadius: 'base',
    py: '1',
    px: '2',
    fontSize: '2xs',
    fontWeight: 'semibold',
  },
};

export const AmountInputWrapperWithdrawal: CSSObject = {
  '&&&': {
    '.chakra-input__group': {
      borderRadius: 'md',
      p: '1',
      bg: 'blackAlpha.600',
      border: 'none',
      boxShadow:
        '0px 1px 0px 0px rgba(255, 255, 255, 0.13), 0px 3px 6px 0px rgba(0, 0, 0, 0.2) inset',
      ':has(#amount-input:focus)': {
        bg: 'blackAlpha.500',
        boxShadow:
          '0px 0px 6px 0px rgba(254, 196, 77, 0.6), 0px 0px 0px 2px #FEC44D inset',
      },
      ':has(#amount-input:hover)': {
        bg: 'blackAlpha.400',
        boxShadow:
          '0px 1px 0px 0px rgba(255, 255, 255, 0.13), 0px 3px 6px 0px rgba(0, 0, 0, 0.2) inset',
      },
      '#amount-input': {
        fontSize: 'sm',
        fontWeight: 'bold',
        borderLeft: 'none',
        borderLeftRadius: 'none',
        bg: 'transparent',
        boxShadow: 'none',
        px: '2',
        h: '35px',
        fontFamily: 'accent',
        _placeholder: {
          fontWeight: 'bold',
        },
        _focus: {
          boxShadow: 'none',
          m: '0',
        },
      },
    },
    '.chakra-input__left-addon': {
      h: 'auto',
      w: '35px',
      border: 'none',
      fontWeight: 'bold',
      px: '0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
};

/**
 * Bank Account Radios
 */
export const BankRadioWrapper: CSSObject = {
  w: 'full',
  alignItems: 'center',
  justifyContent: 'space-between',
  py: '3',
  px: '2',
  borderBottom: '1px dashed',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
  borderBottomColor: 'blackAlpha.400',
};

export const BankRadio: CSSObject = {
  bg: 'white',
  '&[data-checked]': {
    boxShadow: 'none',
    bg: 'gamma.500',
    border: '3px solid',
    borderColor: 'white',
    _hover: {
      bg: 'alpha.200',
      borderColor: 'white',
    },
    _before: {
      display: 'none',
      content: 'unset',
    },
  },
};

export const BankCardContainer: CSSObject = {
  mt: '-3',
  bg: 'transparent',
};

export const FlexBankDetailsContainer: CSSObject = {
  fontSize: 'sm',
};

export const TextBankAccountDetail: CSSObject = {
  '.chakra-checkbox__control': {
    bg: 'white',
  },
  '.chakra-checkbox__control[data-checked]': {
    bg: 'black',
  },
};

/**
 * Withdrawal Requests Aside
 */
export const ListContainer: CSSObject = {
  bg: 'beta.800',
  borderRadius: 'lg',
  boxShadow:
    '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
  mt: '3',
  px: '2',
  py: '0',
  w: '100%',
};

export const ListContainerHeading: CSSObject = {
  textTransform: 'uppercase',
  fontFamily: 'accent',
  fontSize: 'lg',
  fontWeight: 'bold',
  mt: '3',
  color: 'alpha.300',
};

/**
 * Withdrawal Request Card
 */
export const TextBankAccountName: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'bold',
};

export const WithdrawalCardDetail: CSSObject = {
  borderBottom: '1px dashed',
  borderColor: '#00000040',
  py: '1.5',
  fontSize: 'xs',
  fontWeight: 'bold',
};

export const WithdrawalStatus = ({ status }: TWithdrawalStatus): CSSObject => ({
  px: '1',
  py: '0.5',
  borderRadius: 'base',
  bg: status === EWithdrawalStatus.Pending && 'alpha.300',
  color: status === EWithdrawalStatus.Pending && 'blackAlpha.800',
  textTransform: 'uppercase',
  fontSize: '2xs',
  lineHeight: 'normal',
});

export const CardTitleWithdrawal: CSSObject = {
  borderBottom: '1px dashed',
  borderColor: 'gray.300',
  fontSize: 'sm',
  fontWeight: 'semibold',
};

export const IncreaseAmountWrapper: CSSObject = {
  mb: '3',
};

export const buttonWithdrawalProps: CustomButtonProps = {
  mt: '2',
  variant: 'solid',
  fontWeight: 'bold',
  h: '26px',
  lineHeight: 1,
};

export const ButtonWithdrawalCardCancel: CSSObject = {
  _before: {
    content: 'none',
  },
  bg: 'transparent',
  border: '2px',
  borderColor: 'alpha.400',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.25)',
  color: 'white',
  _hover: {
    color: 'white',
    bg: 'transparent',
    borderColor: 'alpha.200',
    opacity: 0.9,
  },
  _disabled: {
    opacity: 0.4,
    pointerEvents: 'none',
  },
};

export const FlexWithdrawalWrapper: CSSObject = {
  flexDir: 'column',
};

export const WithdrawalWrapper: CSSObject = {
  p: '2',
  bg: 'linear-gradient(180deg, #FFFFFF1F, #FFFFFF0D)',
  borderStyle: '1px solid',
  borderColor: 'whiteAlpha.300',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.25)',
};

export const WithdrawalCardDetailNumber: CSSObject = {
  borderBottom: '1px solid',
};

export const WithdrawalCardDetailRequested: CSSObject = {
  borderBottom: '1px dashed',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
  borderBottomColor: 'blackAlpha.500',
};

export const InputWithdrawal: CSSObject = {
  '&&&': {
    border: 'none',
    bg: 'blackAlpha.500',
    borderRadius: 'md',
    color: 'white',
    fontFamily: 'accent',
    fontSize: 'xs',
    fontWeight: 'medium',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
    '&:hover': {
      bg: 'blackAlpha.600',
    },
    '&:focus': {
      bg: 'blackAlpha.600',
    },
  },
};
